
export const prepareRequest = (values, isDraft) => {
  const imagesForBE = values.lotImages.map((img, index) => ({
    image: { ...img },
    index,
  }));
  const valuesToSubmit = {
    ...values,
    lotImages: imagesForBE,
    categoryId: values.subcategoryId,
  };
  delete valuesToSubmit.subcategoryId;
  const formData = new FormData();
  Object.keys(valuesToSubmit).forEach(key => {
    if (Array.isArray(valuesToSubmit[key])) {
      if (key === 'lotImages') {
        valuesToSubmit[key].forEach((imgWrapper, index) => {
          const imageValues = Object.values(imgWrapper);
          formData.append(`lotImagesToAdd[${[index]}].Image`, imageValues[0].originFileObj);
          formData.append(`lotImagesToAdd[${index}].Index`, imageValues[0].index);
        });
      }
      if (key === 'tagIds') {
        valuesToSubmit[key].forEach(tag => formData.append('tagIds', tag.id));
      }
    } else {
      formData.append(key, valuesToSubmit[key]);
    }
    if (key === 'locationId') {
      formData.append('LotLocation', JSON.stringify({ Id: values[key], Longitude: 1, Latitude: 1, Zoom: 1 }));
    }
  });
  
  formData.append('isDraft', isDraft);
  return formData;
};
